import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c329cbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-7 justify-start items-center p-10 gap-5 w-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex lg:flex-row flex-col text-left justify-between col-span-7 lg:col-span-6"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[20px] text-black" }, "Nombre", -1))
const _hoisted_4 = {
  key: 0,
  class: "font text-left text-[20px] text-black"
}
const _hoisted_5 = {
  key: 1,
  class: "font text-left text-[20px] text-black"
}
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[20px] text-black" }, "Rut", -1))
const _hoisted_8 = {
  key: 0,
  class: "text-left text-[20px] text-black"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-3 block" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[20px] text-black" }, "ID B", -1))
const _hoisted_11 = {
  key: 0,
  class: "text-left text-[20px] text-black"
}
const _hoisted_12 = {
  key: 1,
  class: "text-left text-[20px] text-black"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[20px] text-black" }, "ID A", -1))
const _hoisted_14 = {
  key: 0,
  class: "text-left text-[20px] text-black"
}
const _hoisted_15 = {
  key: 1,
  class: "text-left text-[20px] text-black"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[20px] text-black" }, " Correo electrónico ", -1))
const _hoisted_17 = {
  key: 0,
  class: "text-left text-[20px] text-black"
}

import { ShareholderResume } from "@/services/shareholder/types";
import { ShareholderService } from "@/services/shareholder/ShareholderService";
import { computed, onMounted, ref, type Ref } from "vue";
import { useRouter } from "vue-router";
import { formatRut } from "@/services/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderCard',
  setup(__props) {

const router = useRouter();
const shareholder: Ref<null | ShareholderResume> = ref(null);
const shareholderService = new ShareholderService();

const shareholderId = computed(() => +router.currentRoute.value.params.id);

async function getShareholderCard() {
  const response = await shareholderService.getShareholderResume(
    shareholderId.value
  );
  if (!response.success) {
    console.log(
      "Ha ocurrido un error al intentar obtener la tarjeta de presentación del accionista"
    );
    return;
  }

  shareholder.value = response.data;
}

onMounted(() => {
  getShareholderCard();
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mdicon, {
      name: shareholder.value?.identificationIconName,
      size: "80",
      class: "col-span-7 lg:col-span-1 bg-[#9BB441] text-white color-white w-[130px] h-[130px] rounded-full flex items-center justify-center"
    }, null, 8, ["name"]),
    (shareholder.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            (!shareholder.value.isBusiness)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(shareholder.value.firstName) + " " + _toDisplayString(shareholder.value.lastName), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(shareholder.value.businessName), 1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (shareholder.value && shareholder.value.identificationRut)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(formatRut)(shareholder.value.identificationRut)), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_9,
          _createElementVNode("div", null, [
            _hoisted_10,
            (shareholder.value && shareholder.value.investorNumberB)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(shareholder.value.investorNumberB), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, "-"))
          ]),
          _createElementVNode("div", null, [
            _hoisted_13,
            (shareholder.value && shareholder.value.investorNumberA)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(shareholder.value.investorNumberA), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, "-"))
          ]),
          _createElementVNode("div", null, [
            _hoisted_16,
            (shareholder.value && shareholder.value.email)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(shareholder.value.email), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})